// extracted by mini-css-extract-plugin
module.exports = {"links":"Header_links__2dpTy","header":"Header_header__2XAj3"};